export enum NotifierTypes {
  CUSTOM = 'Custom Notifier',
  WARNING = 'Warning Notifier',
  SUCCESS = 'SuccessState',
  ERROR = 'ErrorState',
  INFO = 'General',
  NOTIFYWARNING = 'NotifyWarning'
}
